import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, updated, children, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background font-body" data-testid={testid}>
      <header className="bg-navy border-b border-white/5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link">
            <img src="/logo-full.png" alt="LaunchX Academy" className="h-8 w-auto" />
          </Link>
          <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-300 hover:text-cyanx transition-colors">
            <ArrowLeft size={15} /> Back to Website
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-electric">LaunchX Academy · Legal</p>
        <h1 className="mt-3 font-display font-extrabold text-navy text-3xl sm:text-4xl tracking-tight">{title}</h1>
        <p className="mt-3 text-sm text-slate-500">Last Updated: {updated}</p>
        <div className="mt-10 bg-white border border-slate-200/80 rounded-2xl p-6 sm:p-10">{children}</div>
      </main>
      <footer className="bg-[#070C16] border-t border-white/5 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} LaunchX Academy, Rampur, Uttar Pradesh. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" data-testid="legal-footer-privacy" className="text-xs text-slate-400 hover:text-cyanx transition-colors">Privacy Policy</Link>
            <Link to="/terms-and-conditions" data-testid="legal-footer-terms" className="text-xs text-slate-400 hover:text-cyanx transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export const LS = ({ n, title, children }) => (
  <section className={n === 1 ? "" : "mt-9"}>
    <h2 className="font-display font-bold text-navy text-lg">
      {n}. {title}
    </h2>
    <div className="mt-3 text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </section>
);

export const LUl = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1.5">
    {items.map((i) => (
      <li key={i}>{i}</li>
    ))}
  </ul>
);
